import { render } from "./GenderWiseUserCount.vue?vue&type=template&id=2b5b496a"
import script from "./GenderWiseUserCount.vue?vue&type=script&lang=js"
export * from "./GenderWiseUserCount.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/v3-stage.teachers.gov.bd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__